export const PARTNER_QUESTIONS_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerQuestionsUpdated";
export const PARTNER_QUESTIONS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.Questionnaire.OfferPartnerQuestionsInvalidated";
export const PARTNER_QUESTIONACTIONS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.Questionnaire.OfferPartnerQuestionActionsInvalidated";
export const PARTNER_QUESTIONNAIRE_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.Questionnaire.SetQuestionnaireOnDocumentPartnerSucceded";
export const PARTNER_QUESTIONNAIRE_NEXT_QUESTION_COMPLETED =
  "Charisma.Leasing.PublishedLanguage.Events.Questionnaire.NextQuestionCompleted";
export const PARTNER_QUESTIONNAIRE_FINISH_COMPLETED =
  "Charisma.Leasing.PublishedLanguage.Events.Questionnaire.FinishCompleteQuestionnaireSucceded";
export const PARTNER_QUESTIONNAIRE_NOT_FOUND =
  "Charisma.Leasing.PublishedLanguage.Events.Questionnaire.QuestionnaireNotFound";
